import { render, staticRenderFns } from "./popup-generate-self-process.vue?vue&type=template&id=6496c87a&scoped=true"
import script from "./popup-generate-self-process.vue?vue&type=script&lang=js"
export * from "./popup-generate-self-process.vue?vue&type=script&lang=js"
import style0 from "./popup-generate-self-process.vue?vue&type=style&index=0&id=6496c87a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496c87a",
  null
  
)

export default component.exports